var _path, _rect, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40193 28.0965H22.8449C23.9174 28.0965 24.7869 27.2139 24.7869 26.1254V16.2695H5.45996V26.1254C5.45996 27.2139 6.32948 28.0965 7.40193 28.0965Z",
    fill: "url(#paint0_linear_18775_25795)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.45996,
    y: 16.2695,
    width: 19.3269,
    height: 1.44231,
    fill: "#FCB519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9951 11.6543L6.02634 11.6543C4.91632 11.6543 4.0166 12.5366 4.0166 13.6248V15.4154C4.0166 15.8872 4.40674 16.2697 4.88773 16.2697H25.6455C26.1269 16.2697 26.5166 15.8872 26.5166 15.4154V13.6248C26.5166 12.5366 25.6169 11.6543 24.5069 11.6543H18.7092L11.9951 11.6543Z",
    fill: "url(#paint1_linear_18775_25795)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.437 11.6538H11.3862C8.67257 11.2821 5.35128 8.91274 6.15968 6.41264C6.89519 4.13747 9.10215 2.98674 11.3585 3.00012C14.5437 3.0172 15.3687 9.33731 15.3687 9.33731H15.454C15.454 9.33731 16.2795 3.0172 19.4642 3.00012C21.7197 2.98674 23.9271 4.13747 24.6626 6.41264C25.471 8.91274 22.1497 11.2821 19.437 11.6538ZM21.8064 5.2972C21.8064 5.2972 21.7077 8.40746 17.2923 10.7302C17.2923 10.7302 18.127 6.73717 21.8064 5.2972ZM9.0537 5.2972C12.7317 6.73672 13.5659 10.7302 13.5659 10.7302C9.15152 8.40746 9.0537 5.2972 9.0537 5.2972Z",
    fill: "url(#paint2_linear_18775_25795)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18775_25795",
    x1: 5.45996,
    y1: 17.058,
    x2: 15.6217,
    y2: 35.0476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18775_25795",
    x1: 4.0166,
    y1: 11.962,
    x2: 5.70935,
    y2: 20.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18775_25795",
    x1: 6.03613,
    y1: 3.57692,
    x2: 12.937,
    y2: 17.5188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C3F88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4965A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBoxIcon);
export default __webpack_public_path__ + "static/media/gift-box-icon.45543872f345449cf0e8d00132631f1f.svg";
export { ForwardRef as ReactComponent };